document.addEventListener('DOMContentLoaded', () => {
    // const $NavTitem = $('.product-nav-item')

    // $NavTitem.click(function() {
    //     $NavTitem.removeClass('active')
    //     $(this).addClass('active')
    // })
});